<template>
  <div class="mall-toast-host" aria-live="polite" aria-relevant="additions">
    <transition-group name="mall-toast">
      <div
        v-for="item in toasts"
        :key="item.id"
        class="mall-toast"
        :class="`is-${item.tone}`"
        role="status"
      >
        <AppIcon :icon="toneIcon(item.tone)" :size="18" />
        <p>{{ item.message }}</p>
        <button type="button" aria-label="닫기" @click="dismissToast(item.id)">
          <AppIcon icon="mdi-close" :size="16" />
        </button>
      </div>
    </transition-group>
  </div>
</template>

<script setup lang="ts">
import AppIcon from '@/components/common/AppIcon.vue'
import { useMallToast, type MallToastTone } from '@/composables/useMallToast'

const { toasts, dismissToast } = useMallToast()

function toneIcon(tone: MallToastTone) {
  if (tone === 'success') return 'mdi-check-circle-outline'
  if (tone === 'error') return 'mdi-alert-circle-outline'
  return 'mdi-information-outline'
}
</script>

<style lang="scss" src="./MallToastHost.scss"></style>
